import { SDSInfo } from 'interface';
import axiosAuthoringInstance, { post } from './constants';

export const updateAuthoringCustomerLogo = (
  data: FormData
) => {
  return post(`/sdsAuthoring/utils/change_logo/`, data);
};

export const updateLogoPosition = (
  sdsId: string | number,
  preSelectPosition: string
) => {
  return axiosAuthoringInstance
    .patch(`/sdsAuthoring/files/${sdsId}/`, {
      logo_position: preSelectPosition,
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const updateSupplierInfo = (id: string | number, data: any) => {
  return axiosAuthoringInstance
    .patch(`/sdsAuthoring/supplierInfo/${id}/`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const updateManufacturerInfo = (id: string | number, data: any) => {
  return axiosAuthoringInstance
    .patch(`/sdsAuthoring/manufacturerInfo/${id}/`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const updateSdsData = (
  sdsId: string | number,
  data: Partial<SDSInfo>
) => {
  return axiosAuthoringInstance
    .patch(`/sdsAuthoring/files/${sdsId}/`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};
